import { Component, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';

import { LogoutService } from './logout.service';
import { ModalModule, ModalComponent } from 'atlas-modal';

@Component({
  standalone: false,
  selector: 'dsp-logout',
  templateUrl: 'logout.component.html',
})
export class LogoutComponent {
  @ViewChild(ModalComponent)
  public modal: ModalComponent;


  public constructor(
    private readonly store: Store<AppState>,
    private readonly logoutService: LogoutService
  ) {
  }

  public open(): void {
    this.modal.launch();
  }

  public cancel(): void {
    this.modal.closeModal();
  }

  public continue(): void {
    this.logoutService._continue();
  }
}
